const ClientFilterReducer = (state = [], action) => {
    switch (action.type) {
        case 'ADD_CLIENT_FILTER':
            return [...state, action.payload];
        case 'REMOVE_CLIENT_FILTER':
            return state.filter((_, i) => i !== action.payload);
        case 'CLEAR_FILTERS':   // piggyback on the existing clear action
        case 'CLEAR_CLIENT_FILTERS':
            return [];
        default:
            return state;
    }
};

export default ClientFilterReducer;
